<template>
  <v-dialog
    v-model="active"
    width="500"
  >
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind="{ on }"/>
    </template>

    <v-card>
      <v-card-title
        class="title grey lighten-4"
        primary-title
      >
        Criar pasta
      </v-card-title>
      <v-card-text>
        <v-container
          class="fill-height"
        >
          <v-row
            class="ma-0 pt-4"
          >
            <v-text-field
              v-model="nmProject"
              label="Nome da Pasta"
              prepend-icon="mdi-folder"
              :error-messages="nmProjectErrors"
              outlined
            >
            </v-text-field>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-btn
          color="accent"
          text
          @click="active = false"
        >
          Fechar
        </v-btn>
        <v-spacer/>
        <v-btn
          color="primary"
          @click="onCreateClick"
          :loading="isCreating"
        >
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {validationMixin} from "vuelidate"
  import required from "vuelidate/src/validators/required"
  import maxLength from "vuelidate/src/validators/maxLength"
  import minLength from "vuelidate/src/validators/minLength"
  import {NOTIFICATION_TYPES, NotificationOptions} from "../../../helpers/notify"
  import {mapActions} from "vuex"
  import {CREATE_PROJECT} from "../../../store/modules/project"

  export default {
    name: "ProjectCreateDialog",
    mixins: [validationMixin],
    data: () => ({
      active: false,
      isCreating: false,
      nmProject: null,
    }),
    validations: {
      nmProject: {
        required,
        maxLength: maxLength(60),
        minLength: minLength(4),
      },
    },
    methods: {
      onCreateClick() {
        this.$v.$touch()

        if (this.$v.$invalid) return

        this.isCreating = true

        let projectData = {
          nm_project: this.nmProject,
        }
        this._createProject(projectData)
          .then(() => {
            this.$notify(new NotificationOptions({
              message: "Pasta criada com sucesso!",
              type: NOTIFICATION_TYPES.SUCCESS,
            }))
            this.nmProject = null
            this.$v.$reset()
          })
          .catch(() => {
            this.$notify(new NotificationOptions({
              message: "Ocorreu um erro inesperado ao criar sua pasta, por favor tente novamente mais tarde",
              type: NOTIFICATION_TYPES.ERROR,
            }))
          })
          .finally(() => {
            this.active = false
            this.isCreating = false
          })
      },
      ...mapActions({
        _createProject: CREATE_PROJECT,
      }),
    },
    computed: {
      nmProjectErrors() {
        const errors = []
        if (!this.$v.nmProject.$dirty) return errors
        !this.$v.nmProject.required && errors.push("Esse campo é obrigatório")
        !this.$v.nmProject.minLength && errors.push("O nome da pasta precisa ter no minimo 4 caracteres")
        !this.$v.nmProject.maxLength && errors.push("O nome da pasta pode ter no máximo 60 caracteres")
        return errors
      },
    },

  }
</script>

<style scoped>

</style>
